<script setup>
import { useNavigationToCards } from '#imports';

const props = defineProps({
  navigationItems: {
    type: Array,
    required: true,
  },
});

const { scrollToElement, activeLinkId } = useNavigationToCards(
  props.navigationItems
);
</script>

<template>
  <ul class="article-cards-navigation">
    <li
      v-for="(item, index) in navigationItems"
      :key="item.id"
      class="article-cards-navigation__item"
      :class="{
        'article-cards-navigation__item--active': activeLinkId === item.id,
      }"
      @click="scrollToElement(item.id)"
    >
      {{ index + 1 }}. {{ item.text }}
    </li>
  </ul>
</template>

<style lang="postcss" scoped>
.article-cards-navigation {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__item {
    padding: 16px;
    border-radius: 16px;
    background-color: rgba(248, 249, 250, 20%);
    cursor: pointer;
    color: var(--white-color);
    transition: var(--default-transition) background-color;

    &:hover {
      color: var(--black-color);
      background-color: rgba(255, 246, 251, 96%);
    }

    &--active {
      color: var(--black-color);
      background-color: rgba(255, 246, 251, 96%);
      cursor: default;
    }
  }
}
</style>
